var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#EFF3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0003 19.168C28.507 19.168 25.667 22.008 25.667 25.5013C25.667 28.928 28.347 31.7013 31.8403 31.8213C31.947 31.808 32.0537 31.808 32.1337 31.8213C32.1603 31.8213 32.1737 31.8213 32.2003 31.8213C32.2137 31.8213 32.2137 31.8213 32.227 31.8213C35.6403 31.7013 38.3203 28.928 38.3337 25.5013C38.3337 22.008 35.4937 19.168 32.0003 19.168Z",
    fill: "#002C8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7733 35.3678C35.0533 32.8878 28.9866 32.8878 25.2399 35.3678C23.5466 36.5011 22.6133 38.0345 22.6133 39.6745C22.6133 41.3145 23.5466 42.8345 25.2266 43.9545C27.0933 45.2078 29.5466 45.8345 31.9999 45.8345C34.4533 45.8345 36.9066 45.2078 38.7733 43.9545C40.4533 42.8211 41.3866 41.3011 41.3866 39.6478C41.3733 38.0078 40.4533 36.4878 38.7733 35.3678Z",
    fill: "#002C8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc3);
export default __webpack_public_path__ + "static/media/ic3.d6643316f0a1599f6de72ed08e142bad.svg";
export { ForwardRef as ReactComponent };